/**
 * SSR-safe breadcrumb state management using Nuxt's useState
 * This ensures breadcrumbs set in asyncData are available immediately during SSR and hydration
 */
export const useBreadcrumbs = () => {
  const breadcrumbs = useState('breadcrumbs', () => []);

  const setBreadcrumbs = (crumbs) => {
    breadcrumbs.value = crumbs;
  };

  const clearBreadcrumbs = () => {
    breadcrumbs.value = [];
  };

  return {
    breadcrumbs,
    setBreadcrumbs,
    clearBreadcrumbs,
  };
};
